module.exports = __webpack_public_path__ + "a46f191386c17d08355ce51de2852ef5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/picmobile17.png
// module id = 1877
// module chunks = 0